<template>
    <MasterTemplate 
        title="ผู้ใช้งานแต่ละกลุ่ม" 
        itemKey="userGroupId"
        :headers="headers" 
        :setData="setData"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        >
        <template v-slot:formInput="{editedIndex, rules}">
            <v-row v-if="editedIndex == -1">
                <v-col cols="6" >
                    <v-autocomplete
                        v-model="editedItem.groupCode"
                        label="กลุ่ม"
                        :items="groups"
                        item-text="groupName"
                        item-value="groupCode"
                        :rules="[rules.required]"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-autocomplete
                    v-model="editedItem.usernames"
                    :items="users"
                    dense
                    chips
                    small-chips
                    label="ชื่อผู้ใช้งาน"
                    multiple
                    :rules="[rules.required]"
                ></v-autocomplete>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listUserGroup, listAvaliableGroup, listUserByGroup, insert, update, deleteUserGroup} from '@/api/user-group-api.js'
import {list} from '@/api/master/user-api.js'

export default {
    name: 'Group',
    components: {
        MasterTemplate
    },
    data: () => ({
        headers: [
            {text: 'รหัสกลุ่ม', value: 'groupCode'},
            {text: 'ชื่อกลุ่ม', value: 'groupName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            userGroupId: '-1',
            groupCode: '',
            usernames: ''
        },
        groups: [],
        users: [],
        editedItem: {
            userGroupId: '-1',
            groupCode: '',
            usernames: []
        }
    }),
    methods: {
        listData() {
            return listUserGroup();
        },
        deleteData(item) {
            return deleteUserGroup(item.userGroupId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.groupName;
        },
        setData(item) {
            this.editedItem = item;
        },
        onOpenDialog() {
            listAvaliableGroup().then(rs => {
                this.groups = rs;
            });
            list().then(rs => {
                rs.forEach((v, i) => {
                    this.users.push(v.username);
                });
                listUserByGroup(this.editedItem.groupCode).then(rs => {
                    rs.forEach((v, i) => {
                        this.editedItem.usernames.push(v);
                    });
                });
            })
        }
    }

}
</script>